import { render } from "./change-count.vue?vue&type=template&id=dca4f4ac&scoped=true"
import script from "./change-count.vue?vue&type=script&lang=js"
export * from "./change-count.vue?vue&type=script&lang=js"

import "./change-count.vue?vue&type=style&index=0&id=dca4f4ac&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca4f4ac"]])

export default __exports__